
import React, { useEffect } from 'react';
import CardPartner from './CardPartner';
import Footer from './Footer';
import Head from './Header';
function ChiSiamo() {

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }, []);

    return (<>
        <Head></Head>

        <div className="main-header">
            <div className="container">
                <div className="flex">
                    <div className="f1">

                        <div className="col sm-mid">
                            <h2>Il progetto Futura Care nasce dalla volontà, dall’esperienza e dall’impegno di un insieme di forze che credono nel valore di un’assistenza sanitaria attenta e personalizzata.</h2>
                            <span className="blue-line">
                            </span>
                            <p className="margin">Futura Care è una piattaforma multiservizi in grado di semplificare le richieste di assistenza socio-sanitaria da parte di anziani, disabili o semplici utenti. Il nostro gruppo è formato da una rete coordinata ed altamente qualificata di professionisti quali medici, infermieri, fisioterapisti, psicologi, logopedisti, e tanti altri.</p>
                            <><p className="margin">Nel nostro concetto d’agire il paziente viene al primo posto. Lavoriamo con i pazienti e per i pazienti. Garantiamo una Centrale operativa e il nostro centralino sarà a completa disposizione dell’utenza per qualsiasi informazione su ogni forma di assistenza offerta.</p>
                                <br></br>    <p>
                                    Futura Care e la sua vasta gamma di servizi sono pronti ad intervenire per ogni vostra esigenza. Avrete la possibilità di scegliere la tipologia di prestazione, il giorno in cui ricevere l’assistenza e dove è più comodo che vi raggiunga un nostro operatore sanitario.
                                    <br></br>

                                    <br></br>

                                </p></>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <div className="main-header main-headers">
            <div className="con-min container containers colonna flex-cp servizi">
                <div className="text-center margin">
                    <h2 align="center">I nostri partner</h2>
                    <span className="blue-line">

                    </span>
                </div>
                <div className="flex row between scrolling-wrapper-flexbox">

                    <CardPartner />
                </div>
            </div>
        </div>
        <Footer></Footer>  </>
    );
}


export default ChiSiamo;